
const MapLinesSVG = () => {
    return (
        <svg
            width="856"
            height="241"
            viewBox="0 0 856 241"
            fill="none"
            className="w-full h-full"
        >
            {/* Left side gray lines */}
            <path
                id="line-gray-1"
                d="M267.6 143.299 L164.063 4.8864"
                stroke="#B4B4B4"
                strokeDasharray="2 2"
            />
            <path
                id="line-gray-2"
                d="M322.654 142.639 L224.654 236.639"
                stroke="#B4B4B4"
                strokeDasharray="2 2"
            />
            <path
                id="line-gray-3"
                d="M157 0.5 L54 0.5"
                stroke="#B4B4B4"
                strokeDasharray="2 2"
            />
            <path
                id="line-gray-4"
                d="M222 237.5 L119 237.5"
                stroke="#B4B4B4"
                strokeDasharray="2 2"
            />
            <path
                id="line-gray-center"
                d="M432 144.5 L0 144.5"
                stroke="#B4B4B4"
                strokeDasharray="2 2"
            />

            {/* Right side blue lines */}
            <path
                id="line-blue-1"
                d="M541 143 L644.537 4.8864"
                stroke="#0095FF"
                strokeDasharray="2 2"
            />
            <path
                id="line-blue-2"
                d="M582.646 144.354 L678.646 240.354"
                stroke="#0095FF"
                strokeDasharray="2 2"
            />
            <path
                id="line-blue-3"
                d="M645 0.5 L748 0.5"
                stroke="#0095FF"
                strokeDasharray="2 2"
            />
            <path
                id="line-blue-4"
                d="M678 237.5 L781 237.5"
                stroke="#0095FF"
                strokeDasharray="2 2"
            />
            <path
                id="line-blue-center"
                d="M424 144.5 L856 144.5"
                stroke="#0095FF"
                strokeDasharray="2 2"
            />
        </svg>
    )
}

export default MapLinesSVG